import React, { useState } from "react";
import "./Package.css";
import defaultImage from "../../assets/images/package-img-default.png";
import { useTranslation } from "../../contexts/TranslationContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpinnerLoading from "../SpinnerLoading/SpinnerLoading";

const CalculateFormatRangeAndNights = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const formatDate = (date, includeMonth = true, includeYear = true) => {
    const options = {
      day: "numeric",
      ...(includeMonth && { month: "short" }),
      ...(includeYear && { year: "numeric" }),
    };
    return date.toLocaleDateString("en-US", options);
  };

  const sameMonth = startDate.getMonth() === endDate.getMonth();
  const sameYear = startDate.getFullYear() === endDate.getFullYear();
  let formattedRange = "";

  if (sameYear && sameMonth) {
    // Example: May 14 - 21, 2025
    formattedRange = `${formatDate(startDate, true, false)} - ${formatDate(
      endDate,
      false,
      false
    )}, ${startDate.getFullYear()}`;
  } else if (sameYear) {
    // Example: May 30 - Jun 2, 2025
    formattedRange = `${formatDate(startDate, true, false)} - ${formatDate(
      endDate,
      true,
      false
    )}, ${startDate.getFullYear()}`;
  } else {
    // Example: Dec 30, 2025 - Jan 2, 2026
    formattedRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }

  // Days between
  const dayDiff = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) ; // + 1 if add this then get number of days

  return [formattedRange, dayDiff];
};

const Package = ({
  key,
  id,
  image,
  title,
  cities,
  startDate,
  endDate,
  price,
  status,
  onClick,
  onDelete,
}) => {
  const Lang = Cookies.get("preferred_language") || "en";
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const statusToClass = (status) => {
    switch (status) {
      case "Draft":
        return "status-draft";
      case "Pending Review by Admin":
        return "status-pending";
      case "Cancelled":
        return "status-cancelled";
      case "Rejected":
        return "status-rejected";
      case "Approved":
        return "status-approved";
      default:
        return "";
    }
  };

  const handleRequestQuote = async (packageId) => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://crm.alltimestravels.com/api/method/alltimes.www.api.request_custom_package",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${Cookies.get("api_key")}:${Cookies.get(
              "api_secret"
            )}`,
          },
          body: JSON.stringify({
            custom_package: packageId,
          }),
        }
      );
    

      const result = await response.json();

      if (response.ok && result.message && result.status_code !== 404) {
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Request Quote Error:", error);
      toast.error(t("SomthingWrongPleaseTryAgain"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="package-container" onClick={onClick}>
      <div
        className="package-delete-btn"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </div>
      <div className="package-image">
        <img src={defaultImage} alt="package" />
        <div className={`status-div ${statusToClass(status)}`}>{t(status)}</div>
      </div>
      <div className="package-content-container">
        <div className="package-content-texts">
          <div className="package-content-title">{title}</div>
          <div className="package-content-cities">
            {cities.map((city, index) => {
              // const cityParts = city.split(", ");
              // const lastPart = cityParts.pop();
              // const remainingPart = cityParts.join(", ");
              return (
                <React.Fragment key={index}>
                  <span className="city-name">
                    {city.location}
                    {/* <div className='city-name-bold'>{lastPart}</div> */}
                  </span>
                  {index < cities.length - 1 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="15"
                      viewBox="0 0 22 16"
                      fill="none"
                      style={{
                        transform: Lang === "ar" ? "scaleX(-1)" : "none",
                      }}
                    >
                      <path
                        d="M21.7071 8.70711C22.0976 8.31658 22.0976 7.68342 21.7071 7.29289L15.3431 0.928932C14.9526 0.538408 14.3195 0.538408 13.9289 0.928932C13.5384 1.31946 13.5384 1.95262 13.9289 2.34315L19.5858 8L13.9289 13.6569C13.5384 14.0474 13.5384 14.6805 13.9289 15.0711C14.3195 15.4616 14.9526 15.4616 15.3431 15.0711L21.7071 8.70711ZM0 9L21 9V7L0 7L0 9Z"
                        fill="#27346A"
                      />
                    </svg>
                  )}
                </React.Fragment>
              );
            })}
          </div>
          <div className="package-content-date">
            {CalculateFormatRangeAndNights(startDate, endDate)[0]}{" "}
            <span>
              ({CalculateFormatRangeAndNights(startDate, endDate)[1]} {t("Nights")})
            </span>
          </div>
        </div>
        <div className="package-settings">
          <div className="package-settings-btns">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 18 15" fill="none">
                            <path d="M18 7L11 0V4C4 5 1 10 0 15C2.5 11.5 6 9.9 11 9.9V14L18 7Z" fill="black" />
                        </svg>
                        <div className='package-settings-btns-title'>{t("Share")}</div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="16" viewBox="0 0 4 18" fill="none">
                            <path d="M2 14C2.53043 14 3.03914 14.2107 3.41421 14.5858C3.78929 14.9609 4 15.4696 4 16C4 16.5304 3.78929 17.0391 3.41421 17.4142C3.03914 17.7893 2.53043 18 2 18C1.46957 18 0.96086 17.7893 0.585787 17.4142C0.210714 17.0391 0 16.5304 0 16C0 15.4696 0.210714 14.9609 0.585787 14.5858C0.96086 14.2107 1.46957 14 2 14ZM2 7C2.53043 7 3.03914 7.21071 3.41421 7.58579C3.78929 7.96086 4 8.46957 4 9C4 9.53043 3.78929 10.0391 3.41421 10.4142C3.03914 10.7893 2.53043 11 2 11C1.46957 11 0.96086 10.7893 0.585787 10.4142C0.210714 10.0391 0 9.53043 0 9C0 8.46957 0.210714 7.96086 0.585787 7.58579C0.96086 7.21071 1.46957 7 2 7ZM2 0C2.53043 0 3.03914 0.210714 3.41421 0.585787C3.78929 0.960859 4 1.46957 4 2C4 2.53043 3.78929 3.03914 3.41421 3.41421C3.03914 3.78929 2.53043 4 2 4C1.46957 4 0.96086 3.78929 0.585787 3.41421C0.210714 3.03914 0 2.53043 0 2C0 1.46957 0.210714 0.960859 0.585787 0.585787C0.96086 0.210714 1.46957 0 2 0Z" fill="black" />
                        </svg> */}
          </div>

          {/* {price > 0 && (
            <div className="packages-settings-price-container">
              <div className="packages-settings-price">${price}</div>
              <div className="packages-settings-price-text">
                {t("StartingPrice")}
              </div>
            </div>
          )} */}

          {price > 0 ? (
            <div className="packages-settings-price-container">
              <div className="packages-settings-price">${price}</div>
              <div className="packages-settings-price-text">
                {t("StartingPrice")}
              </div>
            </div>
          ) : loading ? (
            <div>
              <SpinnerLoading />
            </div>
          ) : (
            <button
              className="PackageCard-quote-button"
              onClick={(e) => {
                e.stopPropagation();
                handleRequestQuote(id);
              }}
            >
              {t("RequestQuote")}
            </button>
          )}
        </div>
      </div>
    
    </div>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
      </>
  );
};

export default Package;
